export const TRANSLOCO_TRANSLOCO_SCOPE = 'transloco';
